<template>
  <div class="obra-page obra-dashboard-page">
    <div class="obra-page__shell">
      <ObraDashboardHero
        :project="obra"
        :chapters-count="obra.chaptersList.length"
        :tags="projectTags"
        :age-rating-color="ratingColor"
        @edit-project="openEditModal"
        @add-chapter="openModal"
        @open-public-page="openPublicPage"
      />

    <v-dialog v-model="isEditModalOpen" max-width="1050px" scrollable>
      <v-card color="#dadada" class="obra-edit-modal">
        <v-card-title class="headline" style="background-color: #dadada; color: #333;">Editar Obra</v-card-title>
        <v-card-text style="background-color: #dadada;">
          <v-container fluid class="obra-edit-modal__content">
            <ProjectHeroMediaUpload
              :cover-file="editableObra.thumb"
              :banner-file="selectedBannerFile"
              :current-cover="obra.thumb || obra.project_thumb || ''"
              :current-banner="obra.project_banner || ''"
              :title="editableObra.name"
              :description="editableObra.description"
              :metadata="editablePreviewMetadata"
              :age-rating="editablePreviewAgeRating"
              page-sizing
              class="mb-4"
              @cover-selected="editableObra.thumb = $event"
              @banner-selected="selectedBannerFile = $event"
              @error="showSnackbar($event, 'error')"
            />

            <!-- Campo para Título -->
            <v-text-field label="Título" v-model="editableObra.name" outlined dense background-color="#c8c8c8"></v-text-field>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select label="Categoria" v-model="editableObra.project_category_id" :items="categorias"
                  item-text="name" item-value="id" outlined dense disabled background-color="#c8c8c8" class="custom-input"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select label="Gênero" v-model="editableObra.gender_id" :items="generos" item-text="name"
                  item-value="id" outlined dense background-color="#c8c8c8" class="custom-input"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select label="Idioma" v-model="editableObra.language_id" :items="idiomas" item-text="name"
                  item-value="id" outlined dense disabled background-color="#c8c8c8" class="custom-input"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select label="Tipo da Obra" v-model="editableObra.project_type_id" :items="tiposObra"
                  item-text="name" item-value="id" outlined dense disabled background-color="#c8c8c8" class="custom-input"></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select label="Finalizada" v-model="editableObra.completed" :items="situacoes" item-text="name"
                  item-value="value" outlined dense background-color="#c8c8c8" class="custom-input"></v-select>
              </v-col>
            </v-row>
            <!-- Campo para Descrição -->
            <v-textarea label="Descrição" v-model="editableObra.description" outlined dense rows="3" background-color="#c8c8c8"></v-textarea>

            <AgeRatingPickerInline
              v-model="editableObra.age_rating_ids"
              :ageRatings="ageRatings"
              class="mt-2 mb-3"
            />

          </v-container>
        </v-card-text>
        <v-card-actions style="background-color: #dadada;">
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" dark @click="closeEditModal">Cancelar</v-btn>
          <v-btn class="zinnes-primary-btn" dark @click="saveEditedObra">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <add-capitulo :idObra="obraId" @updateNewChapter="updateNewChapter" v-model="isModalOpen"></add-capitulo>

      <main class="obra-page__main">
        <div class="obra-dashboard-page__toolbar">
          <h2>Lista de capitulos</h2>
          <v-btn class="zinnes-primary-btn" dark @click="openModal">
            <v-icon left>mdi-plus</v-icon>
            Adicionar capitulo
          </v-btn>
        </div>

        <ObraChapterList
          :chapters="obra.chaptersList"
          :project-thumb="obra.thumb || obra.project_thumb"
          :expanded="true"
          :is-admin="true"
          :show-expand-control="false"
          :show-like="false"
          :show-social-meta="false"
          :show-heading="false"
          heading="Capitulos da obra"
          empty-text="Este projeto ainda nao tem nenhum capitulo disponivel."
          count-label="capitulos"
          @open-chapter="goToChapter($event.id)"
          @delete-chapter="deleteChapter($event.id)"
        />
      </main>
    </div>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top>
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<style scoped>
.container-obra{
  position: relative;
  .button-edit{
    position: absolute;
    top: 0;
    right: 0;
  }
}

.obra-edit-modal {
  max-height: 90vh;
  overflow: hidden;
}

.obra-edit-modal__content {
  padding: 16px;
}

.obra-edit-modal ::v-deep .v-card__text {
  max-height: calc(90vh - 116px);
  overflow-y: auto;
}

.obra-edit-modal ::v-deep .v-card__actions {
  flex-wrap: wrap;
  gap: 8px;
}

p {
  color: #ABABAB !important;
}

.card-chapter {
  background-color: #161515 !important;
  cursor: pointer;
  position: relative;
}

.card-chapter:hover {
  background-color: #2b2a28 !important;
}

.container-main {
  margin: 0 16px;
  padding: 16px 16px 16px 26px; /* Ajuste para compensar a largura da sidebar (aproximadamente 200px) */
}

.v-img {
  border-radius: 8px;
  max-width: 180px; /* Reduz a imagem da obra */
  max-height: 220px;
}

.v-btn {
  margin-left: 8px;
}

.title {
  font-size: 30px;
  font-weight: bold;
  color: #FFFF;
}

.subtitle {
  font-size: 24px;
  font-weight: 600;
  color: #ABABAB;
}

.description {
  text-align: justify;
  font-size: 16px;
  font-weight: 500;
  color: #ABABAB;
  max-width: 100%;
  padding: 6px;
  width: 100%;
}

.strong-white {
  font-size: 14px;
  font-weight: bold;
  color: #FFF;
}

.info-text {
  font-size: 14px;
  font-weight: 400;
  color: #ABABAB;
}

.btn {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: var(--zinnes-primary);
  z-index: 2; /* Garante que o botão fique acima da área clicável */
}

/* Ajustes para 1024px */
@media (max-width: 1024px) {
  .container-main {
    padding: 12px 12px 12px 136px; /* Reduz padding, mantém espaço para sidebar */
    margin: 0 8px;
  }

  .v-img {
    max-width: 150px; /* Reduz a imagem da obra */
    max-height: 220px;
  }

  .title {
    font-size: 24px; /* Reduz o tamanho da fonte */
  }

  .subtitle {
    font-size: 18px; /* Reduz o tamanho da fonte */
  }

  .description {
    font-size: 13px; /* Reduz a descrição */
  }

  .info-text {
    font-size: 11px; /* Reduz o texto de informações */
  }

  .strong-white {
    font-size: 12px; /* Reduz o tamanho do texto em negrito */
  }

  .v-btn {
    margin-left: 4px;
    font-size: 12px; /* Reduz o texto do botão */
    padding: 8px 12px; /* Reduz o padding do botão */
  }

  .v-row.align-center {
    flex-wrap: wrap; /* Garante que os elementos não quebrem */
  }

  .v-col {
    padding: 8px; /* Reduz o padding das colunas */
  }
}

/* Ajustes para Mobile (abaixo de 960px) */
@media (max-width: 960px) {
  .container-main {
    padding: 8px; /* Remove o padding extra para a sidebar */
    margin: 0 8px;
  }

  .v-img {
    max-width: 100%;
    max-height: 300px;
  }

  .title {
    font-size: 24px;
    text-align: center !important;
  }

  .subtitle {
    font-size: 20px;
  }

  .description {
    font-size: 14px;
  }

  .v-btn {
    margin-left: 4px;
  }

  .card-chapter {
    flex-direction: column; /* Muda para layout em coluna */
    align-items: center;
  }

  .card-chapter .v-col {
    width: 100%;
    text-align: center;
  }

  .info-text {
    font-size: 12px;
  }
}

/* Ajustes para telas menores (abaixo de 600px) */
@media (max-width: 600px) {
  .obra-edit-modal__content {
    padding: 8px;
  }

  .obra-edit-modal ::v-deep .v-card__text {
    max-height: calc(90vh - 132px);
  }

  .obra-edit-modal ::v-deep .v-card__actions .v-btn {
    flex: 1 1 auto;
    margin-left: 0;
  }

  .title {
    font-size: 20px;
  }

  .subtitle {
    font-size: 18px;
  }

  .description {
    font-size: 12px;
  }

  .btn {
    width: 36px;
    height: 36px;
  }
}
</style>

<script>
import AddCapitulo from '@/components/AddCapitulo.vue';
import { getchapters, getGenders, getAgeRatings } from '../server/workService.js';
import TitleService from '@/server/TitleService.js';
import { EditProject } from '@/server/editProject.js';
import UtilMixins from '@/mixins/UtilMixins.js';
import AgeRatingPickerInline from '@/components/AgeRatingPickerInline.vue';
import ObraChapterList from '@/components/obra/ObraChapterList.vue';
import ObraDashboardHero from '@/components/obra/ObraDashboardHero.vue';
import ProjectHeroMediaUpload from '@/components/ProjectHeroMediaUpload.vue';
import { getHighestAgeRating, getProjectAgeRatingIds, normalizeAgeRatingIds } from '@/utils/ageRatings';
import { projectPath } from '@/utils/projectRoutes';
import '@/styles/obra-page/index.css';

export default {
  name: "ListCapituloView",
  mixins: [UtilMixins],
  components: {
    AddCapitulo,
    AgeRatingPickerInline,
    ObraChapterList,
    ObraDashboardHero,
    ProjectHeroMediaUpload,
  },
  data() {
    return {
      isEditModalOpen: false,
      editableObra: {},
      snackbar: {
        show: false,
        message: '',
        color: '',
        timeout: 3500,
      },
      isModalOpen: false,
      obraId: null,
      obra: {
        name: '',
        thumb: '',
        description: '',
        chapters: 0,
        publication_date: '',
        last_update: '',
        chaptersList: []
      },
      service: new TitleService(),
      situacoes: [
        { name: 'Sim', value: 1 },
        { name: 'Não', value: 0 },
      ],
      idiomas: [
        { id: 1, name: 'Português', value: 'pt-br' },
        { id: 2, name: 'Inglês' },
        { id: 3, name: 'Espanhol' }
      ],
      tiposObra: [
        { id: 1, name: 'Série' },
        { id: 2, name: 'On Shot' },
        { id: 6, name: 'Revista' }
      ],
      categorias: [
        { id: 1, name: 'Quadrinhos' },
      ],
      generos: [],
      ageRatings: [],
      selectedBannerFile: null,
    };
  },
  props: ['idObra'],
  async created() {
    this.list();
    this.generos = await getGenders();
    const ratings = await getAgeRatings();
    this.ageRatings = ratings?.data || ratings || [];
  },
  computed: {
    projectTags() {
      return [
        this.obra.category?.name || this.findName(this.categorias, this.obra.project_category_id),
        this.obra.type?.name || this.findName(this.tiposObra, this.obra.project_type_id),
        this.obra.gender?.name || this.findName(this.generos, this.obra.gender_id),
        this.obra.language?.name || this.findName(this.idiomas, this.obra.language_id),
        this.obra.completed ? 'Finalizada' : 'Em andamento',
      ];
    },
    editablePreviewAgeRating() {
      const selectedIds = normalizeAgeRatingIds(this.editableObra.age_rating_ids);
      const fallback = selectedIds.length ? this.obra.age_rating || null : null;
      return getHighestAgeRating(this.ageRatings, selectedIds, fallback);
    },
    editablePreviewMetadata() {
      return [
        this.findName(this.categorias, this.editableObra.project_category_id),
        this.findName(this.tiposObra, this.editableObra.project_type_id),
        this.findName(this.generos, this.editableObra.gender_id),
        this.findName(this.idiomas, this.editableObra.language_id),
        this.editableObra.completed ? 'Finalizada' : 'Em andamento',
      ];
    },
  },
  methods: {
    openEditModal() {
      this.editableObra = {
        ...this.obra,
        age_rating_ids: getProjectAgeRatingIds(this.obra),
      };
      this.selectedBannerFile = null;
      this.isEditModalOpen = true;
    },
    closeEditModal() {
      this.isEditModalOpen = false;
      this.selectedBannerFile = null;
      this.editableObra = {};
    },
    async list() {
      try {
        this.obraId = this.idObra;
        const chapters = await getchapters(this.idObra);
        const project = chapters.project || {};
        this.obra = {
          ...project,
          age_rating_ids: getProjectAgeRatingIds(project),
          chaptersList: chapters.chapters
        };
      } catch (error) {
        this.showSnackbar('Erro ao carregar dados do projeto com ID: ' + this.idObra, 'error');
      }
    },
    updateNewChapter(newObras) {
      this.obra.chaptersList = newObras;
    },
    async deleteChapter(id) {
      let params = { id };
      await this.service.delete(params);
      this.list();
    },
    openModal() {
      this.isModalOpen = true;
    },
    goToChapter(idCapitulo) {
      this.$router.push({ name: 'ListPagesCapituloView', params: { idCapitulo } });
    },
    openPublicPage() {
      this.$router.push(projectPath(this.obra));
    },
    showSnackbar(message, type) {
      this.snackbar.message = message;
      this.snackbar.color = type === 'success' ? 'green' : 'red';
      this.snackbar.show = true;
    },
    async saveEditedObra() {
      if (!this.editableObra) return;

      const formattedData = new FormData();
      formattedData.append('id', this.editableObra.id);
      formattedData.append('name', this.editableObra.name);
      formattedData.append('description', this.editableObra.description);
      formattedData.append('project_category_id', this.editableObra.project_category_id);
      formattedData.append('gender_id', this.editableObra.gender_id);
      formattedData.append('project_type_id', this.editableObra.project_type_id);
      formattedData.append('language_id', this.editableObra.language_id);
      formattedData.append('completed', this.editableObra.completed);

      if (this.isFile(this.editableObra.thumb))
        formattedData.append('project_thumb', this.editableObra.thumb);

      if (this.isFile(this.selectedBannerFile))
        formattedData.append('project_banner', this.selectedBannerFile);

      formattedData.append('age_rating_ids', JSON.stringify(normalizeAgeRatingIds(this.editableObra.age_rating_ids)));

      await EditProject(formattedData);
      this.list();
      this.isEditModalOpen = false;
      this.selectedBannerFile = null;
      this.editableObra = {};
    },
    isFile(value) {
      return Object.prototype.toString.call(value) === '[object File]';
    },
    findName(items, id) {
      const item = items.find((entry) => entry.id === id);
      return item ? item.name : '';
    },
    ratingColor(age) {
      if (age <= 10) return '#0095DA';
      if (age <= 12) return '#FBC115';
      if (age <= 14) return '#F58220';
      return '#EC1D25';
    }
  }
};
</script>
